import { render } from "./TraderRewardSettingsForm.vue?vue&type=template&id=585e644d&ts=true"
import script from "./TraderRewardSettingsForm.vue?vue&type=script&lang=ts"
export * from "./TraderRewardSettingsForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__